export default __webpack_public_path__ + "static/media/icons-examine-test.0d97ffa5.svg";